import { render, staticRenderFns } from "./barraInferior.vue?vue&type=template&id=30e228aa&scoped=true"
import script from "./barraInferior.vue?vue&type=script&lang=js"
export * from "./barraInferior.vue?vue&type=script&lang=js"
import style0 from "./barraInferior.vue?vue&type=style&index=0&id=30e228aa&prod&lang=css"
import style1 from "./barraInferior.vue?vue&type=style&index=1&id=30e228aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e228aa",
  null
  
)

export default component.exports